export default "__VITE_ASSET__CZCn13zq__"